var _defs, _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBarVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #1d1e30;\n      }\n\n      .st1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2,3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v17.6c0,.3.2.5.4.5,0,0,0,0,0,0h21.7c.3,0,.5-.2.5-.5s-.2-.5-.5-.5H2V3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 3.1,
    y: 12.9,
    width: 5,
    height: 6,
    rx: 1,
    ry: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10.1,
    y: 6.9,
    width: 5,
    height: 12,
    rx: 1,
    ry: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 17.1,
    y: 7.9,
    width: 5,
    height: 11,
    rx: 1,
    ry: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarVertical);
export default __webpack_public_path__ + "static/media/chart-bar-vertical.b2ba31071ed3e5871ef428cd26deb983.svg";
export { ForwardRef as ReactComponent };